import { render, staticRenderFns } from "./Mybottommenu.vue?vue&type=template&id=21194981&scoped=true"
import script from "./Mybottommenu.vue?vue&type=script&lang=js"
export * from "./Mybottommenu.vue?vue&type=script&lang=js"
import style0 from "./Mybottommenu.vue?vue&type=style&index=0&id=21194981&prod&scoped=true&lang=css"
import style1 from "./Mybottommenu.vue?vue&type=style&index=1&id=21194981&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21194981",
  null
  
)

export default component.exports